import Psfs from 'lib/psfs/Psfs'
import React, { Component } from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import {
  Button,
  Dialog,
  DialogActions,
  IconButton,
  Slide,
} from '@material-ui/core'
import { Close } from '@material-ui/icons'
import withPromise from 'helpers/withPromise'
import {
  createJob,
  reloadJobList,
  setActiveState,
} from 'reducers/myJobs/reducer'
import ConfirmDialog from 'components/common/Popup/ConfirmDialog'
import Loader from 'components/Loading/SmallLoader'
import { locusFetchList, fetchLocusTree } from 'reducers/locus/reducer'
import { fetchLocusGroupList } from 'reducers/locusGroup/reducer'
import WorkflowList from './WorkflowList'
import StepConfiguration from './StepConfiguration'
import StepAssign from './StepAssign'
import StepPlanning from './StepPlanning'
import Breadcrumbs from './Breadcrumbs'
import messages from '../translate'

class JobCreation extends Component {
  constructor(props) {
    super(props)
    this.state = this.getInitState(props)
    this.isSubmitting = false
  }

  componentDidUpdate(prevProps, prevState) {
    const { workflowInfo } = this.props
    const { activeStep } = this.state
    const { activeStep: prevActiveStep } = prevState

    if (activeStep === 1 && prevActiveStep === 0) {
      this.checkCoincidences(workflowInfo.get('tasks'))
    }
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.activeSite !== nextProps.activeSite) {
      this.setState(this.getInitState(nextProps))

      return false
    }

    return true
  }

  getInitState = ({ activeSite }) => {
    const startDateTime = this.applyTimezone(moment())
    const endDateTime = startDateTime.clone().add(1, 'day')

    return {
      automaticDueDate: false,
      startDateTime,
      endDateTime,
      activeStep: 0,
      activeSteps: [0],
      activeWorkflow: {
        id: null,
        title: '',
      },
      jobsCount: 1,
      isDisabledNextButton: false,
      isDisabledFinishButton: false,
      isConfirmDialogOpen: false,
      allSelectedUsers: [],
      allSelectedGroups: [],
      formTasks: [],
      initAssign: false,
      unitsAndUnitGroupsData: [],
      form: {
        site: activeSite ? activeSite.get('id') : null,
        workflow: null,
        allowed_locuses_and_groups: [],
        tasks: [],
      },
    }
  }

  applyTimezone = (value, keepDate = false) => {
    const { site, licensee } = this.props
    const timezone = site?.timezone || licensee?.timezone

    return timezone ? value.tz(timezone, keepDate) : value
  }

  setUnitsAndUnitGroupsData = (data, callback = () => {}) => {
    this.setState(
      {
        unitsAndUnitGroupsData: data,
      },
      () => {
        callback()
      },
    )
  }

  updateAssign = ({ formTasks, allSelectedUsers, allSelectedGroups }) => {
    this.setState(
      {
        formTasks,
        allSelectedUsers,
        allSelectedGroups,
      },
      () => this.onSetAssignStep(formTasks),
    )
  }

  setInitAssign = initAssign => {
    this.setState({ initAssign })
  }

  getClearStateParamsByStep = step =>
    step === 0 ? this.getInitState(this.props) : {}

  handleDisableNexButton = enable => {
    this.setState({
      isDisabledNextButton: !!enable,
    })
  }

  goToNextStep = (step = 1) => {
    const { activeStep, activeSteps } = this.state
    const nextStep = activeStep + step
    this.setState({
      activeStep: nextStep,
      activeSteps: [...activeSteps, nextStep],
    })
  }

  goToPrevStep = () => {
    const { activeSteps } = this.state
    const prevSteps = activeSteps.slice(0, activeSteps.length - 1)
    const prevStep = prevSteps[prevSteps.length - 1]
    this.setState({
      activeStep: prevStep,
      activeSteps: prevSteps,
      ...this.getClearStateParamsByStep(prevStep),
    })
  }

  onSetWorkflowStep = workflow => {
    const {
      id,
      title,
      automatic_due_date: automaticDueDate,
      automatic_due_date_days: automaticDueDateDays,
      automatic_due_date_time: automaticDueDateTime,
    } = workflow

    const startDateTime = this.applyTimezone(moment())
    const endDateTime = startDateTime.clone()
    if (automaticDueDate) {
      const [hours, minutes, seconds] = automaticDueDateTime.split(':')
      endDateTime
        .add(automaticDueDateDays, 'day')
        .set('hours', hours)
        .set('minutes', minutes)
        .set('seconds', seconds)
    } else {
      endDateTime.add(1, 'day')
    }
    const nextState = {
      activeWorkflow: {
        id,
        title,
      },
      automaticDueDate,
      startDateTime,
      endDateTime,
      form: {
        workflow: workflow.id,
      },
    }

    this.setState(prevState => {
      const { form: prevForm } = prevState
      if (automaticDueDate) {
        nextState.form = {
          ...prevForm,
          ...nextState.form,
          start_date_time: startDateTime.format('YYYY-MM-DD HH:mm:ss'),
          end_date_time: endDateTime.format('YYYY-MM-DD HH:mm:ss'),
        }
      } else {
        const { start_date_time, end_date_time, ...restForm } = prevForm
        nextState.form = {
          ...restForm,
          ...nextState.form,
        }
      }

      return nextState
    })
  }

  onSetConfigurationStep = groupsAndCages => {
    this.setState(prevState => ({
      form: {
        ...prevState.form,
        allowed_locuses_and_groups: groupsAndCages,
      },
    }))
  }

  onSetAssignStep = tasks => {
    this.setState(prevState => ({
      form: {
        ...prevState.form,
        tasks,
      },
    }))
  }

  onSetPlanedStep = (planed, jobsCount) => {
    const {
      form: { site, workflow, allowed_locuses_and_groups, tasks },
    } = this.state

    this.setState({
      jobsCount,
      form: {
        site,
        workflow,
        allowed_locuses_and_groups,
        tasks,
        ...planed,
      },
    })
  }

  onFormSubmit = () => {
    if (this.isSubmitting) {
      return
    }

    this.isSubmitting = true

    const {
      createJob,
      reloadJobList,
      formatMessage,
      setActiveState,
    } = this.props
    const { form } = this.state
    let jobsActiveState = 'active'

    this.setState({ isDisabledFinishButton: true })

    withPromise(createJob, {
      form,
      errorMessage: formatMessage(messages.createJobErrorMessage),
    }).then(({ error }) => {
      if (!error) {
        if (
          form.start_date_time &&
          moment(form.start_date_time).isAfter(moment())
        ) {
          jobsActiveState = 'future'
        }

        setActiveState(jobsActiveState)
        reloadJobList()
        this.onCloseDialog()
      } else {
        this.setState({ isDisabledFinishButton: false })
      }

      this.isSubmitting = false
    })
  }

  onCloseDialog = () => {
    this.setState(this.getInitState(this.props), this.props.onCloseDialog)
  }

  onOpenConfirmDialog = () => {
    this.setState({ isConfirmDialogOpen: true })
  }

  onCloseConfirmDialog = () => {
    this.setState({ isConfirmDialogOpen: false })
  }

  renderStepButton = (text, onClick, disabled = false) => {
    const { jobCreationLoading } = this.props

    return (
      <Button
        fullWidth
        size="large"
        color="primary"
        variant="contained"
        className="btn-step"
        onClick={() => onClick()}
        disabled={disabled}>
        {jobCreationLoading ? <Loader /> : text}
      </Button>
    )
  }

  getUnitTree = () => {
    const { activeSite, fetchLocusTree } = this.props
    const activeSiteId = activeSite.get('id')
    const psfs = new Psfs()
    psfs
      .addFilter('site', activeSiteId)
      .addFilter('active', 1)
      .addFilter('visibleInUi', 1)

    fetchLocusTree({ psfs })
  }

  getUnitList = () => {
    const { activeSite, locusFetchList } = this.props
    const activeSiteId = activeSite.get('id')
    const psfs = new Psfs()
    psfs
      .addFilter('active', 1)
      .addFilter('visibleInUi', 1)
      .addFilter('site', activeSiteId)
      .addFields(['id', 'containerName'])

    locusFetchList({ psfs })
  }

  getUnitGroupList = () => {
    const { activeSite, fetchLocusGroupList } = this.props
    const activeSiteId = activeSite.get('id')
    const psfs = new Psfs()
    psfs
      .addFilter('active', 1)
      .addFilter('visibleInUi', 1)
      .addFilter('site', activeSiteId)
      .addFields(['id', 'name'])

    fetchLocusGroupList({ psfs })
  }

  checkCoincidences = () => {
    const { workflowInfo } = this.props
    const { needs_locus, needs_locus_group } = workflowInfo.toJS()

    if (needs_locus && needs_locus_group) {
      this.getUnitTree()
    } else if (needs_locus_group && !needs_locus) {
      this.getUnitGroupList()
    } else if (needs_locus && !needs_locus_group) {
      this.getUnitList()
    } else {
      this.goToNextStep(1)
    }
  }

  render() {
    const { activeSite } = this.props

    if (!activeSite) {
      return null
    }

    const { isOpen, isFullScreen, formatMessage, featureFlags } = this.props
    const {
      activeStep,
      activeWorkflow,
      jobsCount,
      isDisabledNextButton,
      isDisabledFinishButton,
      isConfirmDialogOpen,
      form: { repeat_frequency },
      allSelectedUsers,
      allSelectedGroups,
      formTasks,
      initAssign,
      unitsAndUnitGroupsData,
      startDateTime,
      endDateTime,
      automaticDueDate,
    } = this.state
    const activeSiteId = activeSite.get('id')
    const activeSiteName = activeSite.get('name')
    const onClickFinishBtn = repeat_frequency
      ? this.onOpenConfirmDialog
      : this.onFormSubmit

    return (
      <Dialog
        disableBackdropClick
        open={isOpen}
        fullScreen={isFullScreen}
        onClose={this.onCloseDialog}
        onBackdropClick={this.onCloseDialog}
        classes={{
          root: 'add-workflow-dialog',
          paper: 'add-workflow-paper',
        }}>
        <DialogActions className="add-workflow-header">
          <Breadcrumbs
            formatMessage={formatMessage}
            siteName={activeSiteName}
            workflow={activeWorkflow}
            step={activeStep}
            backClick={this.goToPrevStep}
          />
          <IconButton onClick={this.onCloseDialog}>
            <Close />
          </IconButton>
        </DialogActions>
        <div className="job-creation">
          {!this.isSubmitting && activeStep === 0 && (
            <Slide in mountOnEnter unmountOnExit direction="left">
              <WorkflowList
                site={activeSiteId}
                onSetForm={this.onSetWorkflowStep}
                goForward={this.goToNextStep}
              />
            </Slide>
          )}
          {activeStep === 1 && (
            <Slide in mountOnEnter unmountOnExit direction="left">
              <div className="creation-content">
                <StepConfiguration
                  site={activeSiteId}
                  formatMessage={formatMessage}
                  handleDisableNext={this.handleDisableNexButton}
                  onSetForm={this.onSetConfigurationStep}
                  checkCoincidences={this.checkCoincidences}
                  data={unitsAndUnitGroupsData}
                  setData={this.setUnitsAndUnitGroupsData}
                />
                {!featureFlags?.JOBS_CREATION_REMOVE_ASSIGNMENT_STEP
                  ? this.renderStepButton(
                      formatMessage(messages.next),
                      this.goToNextStep,
                      isDisabledNextButton,
                    )
                  : this.renderStepButton(
                      formatMessage(messages.finish),
                      onClickFinishBtn,
                      isDisabledFinishButton,
                    )}
              </div>
            </Slide>
          )}
          {activeStep === 2 &&
            !featureFlags?.JOBS_CREATION_REMOVE_ASSIGNMENT_STEP && (
              <Slide in mountOnEnter unmountOnExit direction="left">
                <div className="creation-content">
                  <StepAssign
                    onSetForm={this.onSetAssignStep}
                    updateAssign={this.updateAssign}
                    allSelectedUsers={allSelectedUsers}
                    allSelectedGroups={allSelectedGroups}
                    formTasks={formTasks}
                    setInitAssign={this.setInitAssign}
                    initAssign={initAssign}
                  />
                  {featureFlags.JOBS_SCHEDULING_STEP
                    ? this.renderStepButton(
                        formatMessage(messages.next),
                        this.goToNextStep,
                        isDisabledNextButton,
                      )
                    : this.renderStepButton(
                        formatMessage(messages.finish),
                        onClickFinishBtn,
                        isDisabledFinishButton,
                      )}
                </div>
              </Slide>
            )}
          {activeStep === 3 && featureFlags.JOBS_SCHEDULING_STEP && (
            <Slide in mountOnEnter unmountOnExit direction="left">
              <div className="creation-content">
                <StepPlanning
                  startDateTime={startDateTime}
                  endDateTime={endDateTime}
                  isPlanned={automaticDueDate}
                  formatMessage={formatMessage}
                  onSetForm={this.onSetPlanedStep}
                />
                {this.renderStepButton(
                  formatMessage(messages.finish),
                  onClickFinishBtn,
                  isDisabledFinishButton,
                )}
              </div>
            </Slide>
          )}
        </div>
        <ConfirmDialog
          open={isConfirmDialogOpen}
          title={formatMessage(messages.createJobSeries)}
          className="confirm-action dialog-primary-custom"
          message={formatMessage(messages.createJobSeriesMessage, {
            workflow: activeWorkflow.title,
            count: jobsCount,
          })}
          onConfirmAction={this.onFormSubmit}
          onClose={this.onCloseConfirmDialog}
          cancel={{
            color: 'default',
            variant: 'outlined',
          }}
        />
      </Dialog>
    )
  }
}

export default connect(
  state => ({
    licensee: state.getIn(['profile', 'profile', 'licensee']),
    site: state.getIn(['profile', 'profile', 'site']),
    workflowInfo: state.getIn(['myJobs', 'workflowInfo']),
    activeSite: state.getIn(['myJobs', 'activeSite']),
    jobCreationLoading: state.getIn(['myJobs', 'jobCreationLoading']),
    featureFlags: state.getIn(['profile', 'profile', 'featureFlags']),
  }),
  {
    createJob,
    reloadJobList,
    setActiveState,
    locusFetchList,
    fetchLocusTree,
    fetchLocusGroupList,
  },
)(JobCreation)
